import { Route } from '@angular/router';
import { channels } from './channels';
import { SbIcons } from '@ngx-seatback/icons';
import { RoutingID } from '../../../sb-routing-enum';
import { playerHardware } from './playerHardware';
import { playerSoftware } from './playerSoftware';
import { screenHardware } from './screenHardware';
import { sspContracts } from './ssp-contracts';

export const network: Route = {
  path: 'dataset-network',
  title: 'nav.network',
  data: {
    icon: SbIcons.network,
    breadcrumb: 'nav.network',
  },
  children: [
    channels,
    playerHardware,
    playerSoftware,
    screenHardware,
    sspContracts,
    { path: '', redirectTo: RoutingID.channels, pathMatch: 'full' },
  ],
};
